/* 处理尺码表的英寸/厘米切换，包括动态打开的弹窗 */
(function () {
  if (window.belawaveSizeGuideInitialized) return;
  window.belawaveSizeGuideInitialized = true;

  function setUnit(guide, unit) {
    guide.querySelectorAll('td[data-inch][data-cm]').forEach(function (cell) {
      cell.textContent = cell.dataset[unit];
    });

    ['bust-header', 'waist-header', 'hip-header'].forEach(function (id) {
      var unitLabel = guide.querySelector('#' + id + ' span');
      if (unitLabel) {
        unitLabel.textContent = unit === 'cm' ? 'Centimeters' : 'Inches';
      }
    });

    var inchButton = guide.querySelector('#btn-inch');
    var cmButton = guide.querySelector('#btn-cm');

    if (inchButton) inchButton.classList.toggle('active', unit === 'inch');
    if (cmButton) cmButton.classList.toggle('active', unit === 'cm');
  }

  /* 用委托监听点击，因此弹窗后载入的按钮也能工作 */
  document.addEventListener('click', function (event) {
    var button = event.target.closest('#btn-inch, #btn-cm');
    if (!button) return;

    var guide = button.closest('.belawave-size-guide');
    if (!guide) return;

    setUnit(guide, button.id === 'btn-cm' ? 'cm' : 'inch');
  });

  /* 页面直接打开时，确保尺码表初始显示英寸 */
  function initializeGuides() {
    document.querySelectorAll('.belawave-size-guide').forEach(function (guide) {
      setUnit(guide, 'inch');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeGuides, { once: true });
  } else {
    initializeGuides();
  }
})();